export default __webpack_public_path__ + "static/media/ar3.0b5ffe67.jpg";